module.exports = __webpack_public_path__ + "static/media/sjt1.b85a23dd.jpeg";